module.exports = __webpack_public_path__ + "img/icon-insta.fe7c8574.svg";